import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { uploadFiles } from "Thunks";
import { initUploads } from "Actions";

import styles from "./Wheretobill.local.scss";
import _ from "i18n";

import WheretobillComponent from "./WheretobillComponent";

class WheretobillContainer extends Component {
  onDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles && rejectedFiles.length > 0) {
      toast.error(
        <div>
          <span>{_("Some files are invalid : ")}</span>
          <ul>
            {rejectedFiles.map(file => <li key={file.name}>{file.name}</li>)}
          </ul>
        </div>,
        { autoClose: true }
      );
    }

    if (!acceptedFiles || acceptedFiles.length === 0) {
      return;
    }

    const { uploadFiles } = this.props;

    uploadFiles(acceptedFiles);
  };

  onDragEnter = () => {
    $(`.${styles.big}`).addClass(styles.active);
  };

  componentDidUpdate(prevProps) {
    const { initUploads, uploaded } = this.props;
    if (uploaded) {
      $(`.${styles.check}`).show(500);
      setTimeout(() => {
        initUploads();
        $(`.${styles.check}`).hide();
      }, 1500);
    }
  }

  render() {
    const { uploading, uploaded, loggedAs, user } = this.props;
    if (loggedAs !== "CLIENT") {
      return null;
    }

    return (
      <div className="pellet cell medium-6 large-3">
        <WheretobillComponent
          uploading={uploading}
          uploaded={uploaded}
          onDrop={this.onDrop}
          onDragEnter={this.onDragEnter}
        />
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  uploading: state.wheretobill.uploading,
  uploaded: state.wheretobill.uploaded,
  user: state.auth.user,
  loggedAs: state.auth.loggedAs
});

const mapDispatchToProps = dispatch => ({
  initUploads: () => dispatch(initUploads()),
  uploadFiles: files => dispatch(uploadFiles(files))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WheretobillContainer);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Wheretobill/WheretobillContainer.js